<Modal
  title="Select charity"
  actionTitle="Confirm"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  <p>Is this the charity to which you want to donate your items?</p>
  <p>Your details will be shared with the charity. If they confirm their request, it's a match!</p>

  {#if errorMessage}
    <div class="notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let requestId : string;

  import { logging } from '../../../../../lib/logging';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";

  let errorMessage : string;
  let isLoading = false;

  async function apply() {
    let firebase = window.firebase;

    isLoading = true;

    await firebase
      .functions()
      .httpsCallable('api-request-selectrequest')({ requestId } as SelectRequestParams)
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));

    $uiState.activeModal = undefined;
  }
</script>
